import * as React from "react";
import { BusinessServiceDescriptor } from "src/businessServices";
import { BusinessServiceSettingsPort } from "src/pages/ManagementPage/objects/ports";
import { ZObjectService } from "../../businessServises.types";
import { loadMc2Settings, saveMc2Settings } from "./apiMc2";
import { Mc2Settings } from "./Mc2Settings";
import { zMc2Settings } from "./Mc2Types";
import { Mc2Summary } from "./Mc2Summary";

export const bsMeasurementChart2: BusinessServiceDescriptor = {
  key: "Measurement chart v2",

  renderSettings(
    info: ZObjectService,
    store: BusinessServiceSettingsPort,
  ): React.ReactNode {
    return (
      <Mc2Settings
        modelObjectId={info.objectId}
        loadObjectOptions={() => store.loadObjectOptions()}
      />
    );
  },
  async loadSettings(info: ZObjectService): Promise<object> {
    return loadMc2Settings(info.objectId);
  },
  async saveSettings(info: ZObjectService, values: unknown): Promise<void> {
    const settings = zMc2Settings.parse(values);
    await saveMc2Settings(info.objectId, info.serviceId, settings);
  },
  viewer: (info, data) => <Mc2Summary data={data} />,
};
